import React, { useState, useCallback, useEffect } from "react";
import cn from "classnames";
import styles from "./Header.module.scss";
import Headroom from "react-headroom";
import Navigation from "components/Navigation/Navigation";
import Opacity from "components/Navigation/opacity";
export default function Lll(props) {
  const [navbarOpen, setNavbarOpen] = useState(null);
  setTimeout(() => {
    if (navbarOpen === false) {
      setNavbarOpen(null);
    }
  }, 500);

  useEffect(() => {
    return () => {
      setNavbarOpen(null);
    };
  }, [])

  const handleToggle = () => {
    setNavbarOpen(!navbarOpen);
  };
  const closeOutSideNav = useCallback((data) => {
    setNavbarOpen(data);
  }, []);
  let userName=localStorage.getItem('userName');
  let showUserName=""
  if(userName!==""){
    let userNameLength=userName?.split('@');
    if(userNameLength[0]?.length>20){
      showUserName=userName.slice(0,20)
     }else{
      showUserName=userNameLength[0]
     }
  }
  
  return (
    <React.Fragment>
      <Headroom tag="header" className="page-header">
        <nav
          className={`max:${
            navbarOpen
              ? "customClass"
              : navbarOpen === null
              ? "displaynone"
              : "customHide"
          }`}
        >
          <Opacity closeNav={closeOutSideNav} />
          <Navigation navState={handleToggle} />
        </nav>
      </Headroom>
      <div>
        <div className={cn(styles.header_flex, styles.header_flex_layout)}>
          <div className={cn(styles.header_flex_item)}>
            <img
              src={require("assets/ic_menu_24px.svg").default}
              alt="Rectangle"
              className={cn(styles.nav_ic, styles.nav_ic_layout)}
              onClick={() => handleToggle()}
            />
          </div>
          {/* <div className={cn(styles.header_flex_spacer)} /> */}
          {/* <div className={cn(styles.header_flex_item1)}>
            {props.page_name == 'My Fleet' ? <h2 className={props.checkLayout ? cn(styles.page_title2, styles.page_title_layout2) : cn(styles.page_title, styles.fleet_page_title_layout)}>
              {props.page_name}
              
            </h2> :
              <h2 className={props.checkLayout ? cn(styles.page_title2, styles.page_title_layout2) : cn(styles.page_title, styles.page_title_layout)}>
                {props.page_name}
                
              </h2>
            }
          </div> */}
          <div className={cn(styles.header_flex_spacer1)} />
          <div className={cn(styles.header_flex_item2)}>
            <img
              src={require("assets/logo1.png").default}
              alt="assets/logo.png"
              className={cn(styles.logo_img, styles.logo_img_layout)}
            
            />
          </div>
          <div className={cn(styles.header_flex_spacer2)} />
          <div className={cn(styles.header_flex_item3)}>
            <div
              className={cn(styles.profile_block, styles.profile_block_layout)}
            >
              <div className={cn(styles.profile_block_item)}>
                <img
                  src={require("assets/user.svg").default}
                  alt="Ellipse 1"
                  className={cn(styles.profile_ic, styles.profile_ic_layout)}
              
                />
              </div>
              <div className={cn(styles.profile_block_spacer)} />
              <div className={cn(styles.profile_block_item1)}>
                <div
                  className={cn(
                    styles.profile_detail_block,
                    styles.profile_detail_block_layout
                  )}
                >
                  <h3
                    className={cn(
                      styles.profile_detail_title,
                      styles.profile_detail_title_layout,styles.accountTooltip
                    )}
                  >
                    {/* {"Edward Jacob"} */}
                    {showUserName}
                    {/* <span  className={cn(styles.tooltiptext)}>{userName}</span> */}
                  </h3>
                  <h4
                    className={cn(
                      styles.profile_detail_subtitle,
                      styles.profile_detail_subtitle_layout
                    )}
                  >
                    {"Fleet Manager"}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={cn(styles.header_flex_item1)}>
        {props.page_name === "My Fleet" ? (
          <h2
            className={
              props.checkLayout
                ? cn(styles.page_title2, styles.page_title_layout2)
                : cn(styles.page_title, styles.page_title_layout)
            }
          >
            {
            props.page_name
            }
          </h2>
        ) : (
          <h2
            className={
              props.checkLayout
                ? cn(styles.page_title2, styles.page_title_layout2)
                : cn(styles.page_title, styles.page_title_layout)
            }
          >
            {props.page_name}
          </h2>
        )}
      </div>
    </React.Fragment>
  );
}
